import { module } from 'stereomodularjs';
import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, A11y, EffectCreative, Controller, Mousewheel, Autoplay } from 'swiper/modules';

// Configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar, A11y, EffectCreative, Controller, Mousewheel, Autoplay]);

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.typeSlider = this.el.dataset.type;
        this.autoplay_interval = null;
        this.has_user_interacted = false;

        this.params = {
            direction: 'horizontal',
            loop: false,
            slidesPerView: 'auto',
            grabCursor: true,
            touchEventsTarget: 'container',
            speed: 600,
            mousewheel: {
                enabled: true,
                forceToAxis: true,
                sensitivity: 5, // Ajustez la sensibilité ici
                thresholdDelta: 10, // Ajustez le seuil ici
            },

            pagination: {
                el: this.el.querySelector('.swiper-pagination'),
                clickable: true,
            },

            navigation: {
                nextEl: this.el.querySelector('.swiper-button-next'),
                prevEl: this.el.querySelector('.swiper-button-prev'),
            },

            scrollbar: {
                el: this.el.querySelector('.swiper-scrollbar'),
                draggable: true,
            },

            a11y: {
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
            },
        };

        if (this.typeSlider === 'home-fold-text') {
            this.params.effect = 'creative';
            this.params.creativeEffect = {
                prev: {
                    translate: [0, 0, 0],
                },
                next: {
                    translate: [0, 0, 0],
                },
                progressMultiplier: 2,
            };
        }

        this.slider = new Swiper(this.el, this.params);

        // Vérifier si l'autre slider est présent et les synchroniser
        this.setup_slider_sync();

        // Démarrage autoplay manuel
        if (this.typeSlider === 'home-fold-text') {
            this.start_manual_autoplay();

            // Interaction = on stoppe autoplay
            ['click', 'touchstart', 'mousedown', 'wheel'].forEach(event => {
                this.el.addEventListener(event, () => {
                    this.has_user_interacted = true;
                    this.stop_manual_autoplay();
                }, { once: true }); // déclenché une seule fois
            });

            this.slider.on('touchStart', () => {
                this.handle_user_interaction();
            });
            this.slider.on('sliderFirstMove', () => {
                this.handle_user_interaction();
            });
        }

    }

    setup_slider_sync() {
        if (this.typeSlider === 'home-fold-text') {
            const other_slider_type = 'home-fold-img';
            const other_slider_el = document.querySelector(`[data-type="${other_slider_type}"]`);

            if (other_slider_el) {
                const other_slider = other_slider_el.swiper;

                if (other_slider) {
                    this.slider.controller.control = other_slider;
                    other_slider.controller.control = this.slider;

                    // Ajoute l'écoute des interactions sur le slider synchronisé
                    this.listen_to_other_slider_interaction(other_slider_el, other_slider);
                } else {
                    setTimeout(() => this.setup_slider_sync(), 100);
                }
            }
        }
    }

    listen_to_other_slider_interaction(other_slider_el, other_slider) {
        // Écoute les événements physiques sur le DOM du slider sync
        ['click', 'touchstart', 'mousedown', 'wheel'].forEach(event => {
            other_slider_el.addEventListener(event, () => {
                this.handle_user_interaction();
            }, { once: true });
        });

        // Écoute les événements Swiper sur le slider sync
        other_slider.on('touchStart', () => {
            this.handle_user_interaction();
        });
        other_slider.on('sliderFirstMove', () => {
            this.handle_user_interaction();
        });
    }

    start_manual_autoplay() {
        this.autoplay_interval = setInterval(() => {
            if (!this.slider || this.slider.destroyed || this.has_user_interacted) return;

            const is_end = this.slider.isEnd;

            if (is_end) {
                this.slider.slideTo(0);
            } else {
                this.slider.slideNext();
            }

        }, 5000); // 5000 ms = 5s entre slides
    }

    stop_manual_autoplay() {
        if (this.autoplay_interval) {
            clearInterval(this.autoplay_interval);
            this.autoplay_interval = null;
        }
    }

    handle_user_interaction() {
        if (this.has_user_interacted) return;
        this.has_user_interacted = true;
        this.stop_manual_autoplay();
    }

    destroy() {
        if (this.slider) {
            this.slider.destroy(true, true);
            this.slider = null;
            this.stop_manual_autoplay();
            this.has_user_interacted = false;
        }
    }
}
